/**
 * The default sweep vocabulary — the passes a student (or a class) starts with.
 *
 * Lives here because FOUR places need the same list and the ids are load-bearing:
 * a class plan written against `rev2` merges into a student's plan only because
 * both sides spell it that way. Three independent copies agreed by luck, and
 * nothing made them keep agreeing.
 *
 * `label`/`name` differ by consumer — the student's pass set calls it `label`,
 * a class plan's copy calls it `name` — so the shape is deliberately minimal and
 * each side adapts it. Only the ids and the order have to match.
 *
 * See docs/FeatureDesigns/goals-syllabus-revision-plan/StudyPlanning/domain-model.md §3.6.
 */

export interface DefaultStudyPass {
    id: string;
    label: string;
    order: number;
}

/** Not a schema default and not seeded: it is what a plan STARTS from. A class
 *  or a student may rename, drop or add to it, and their copy is theirs from
 *  that moment — renaming one here never rewrites what anyone already holds. */
export const DEFAULT_STUDY_PASSES: readonly DefaultStudyPass[] = [
    { id: 'read', label: '1st Read', order: 0 },
    { id: 'rev1', label: '1st Revision', order: 1 },
    { id: 'rev2', label: '2nd Revision', order: 2 },
] as const;
